export default {
  bd: 'buruburu-dobutsu@play.co',
};
